import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Page } from "@/components/Layout";
import { api } from "@/lib/api";
import { Calendar } from "@phosphor-icons/react";
import PageLoader from "@/components/PageLoader";
import { useCurrency } from "@/lib/currency";

export default function MentorDetail() {
  const { id } = useParams();
  const { format } = useCurrency();
  const [m, setM] = useState(null);
  useEffect(() => { api.get(`/mentors/${id}`).then((r) => setM(r.data)); }, [id]);
  if (!m) return <Page><PageLoader /></Page>;
  return (
    <Page>
      <section className="md-section">
        <div className="md-container max-w-5xl grid md:grid-cols-3 gap-10">
          <div className="md:col-span-1">
            {m.photo_url && <img src={m.photo_url} alt={m.name} className="rounded-lg w-full aspect-square object-cover" />}
            <div className="md-card mt-5">
              <div className="md-label-eyebrow mb-2">{m.title}</div>
              <p className="text-sm">Languages: {m.languages.join(", ")}</p>
              <p className="text-sm mt-1">Experience: {m.experience_years} yrs</p>
              {m.next_available_slot && (
                <p className="text-sm mt-1" data-testid="mentor-next-available">Next available: {m.next_available_slot}</p>
              )}
              <p className="text-2xl font-serif mt-4" data-testid="mentor-session-fee">{format(m.session_fee)} <span className="text-sm opacity-60">/ session</span></p>
              <Link to={`/book/mentor/${m.id}`} className="btn-primary w-full justify-center mt-4" data-testid="mentor-book-btn"><Calendar size={16} /> Book Session</Link>
            </div>
          </div>
          <div className="md:col-span-2">
            <div className="md-label-eyebrow mb-3">{m.title}</div>
            <h1 className="text-4xl md:text-5xl font-serif mb-5">{m.name}</h1>
            <p className="text-lg break-words" style={{ color: "var(--md-text-soft)", overflowWrap: "anywhere" }}>{m.bio}</p>
            <div className="mt-6">
              <div className="md-label-eyebrow mb-3">Pathways</div>
              <div className="flex flex-wrap gap-2">
                {m.pathways.map((s) => <span key={s} className="md-tag">{s}</span>)}
              </div>
            </div>
            <div className="mt-6">
              <div className="md-label-eyebrow mb-3">Session Types</div>
              <div className="flex flex-wrap gap-2">
                {m.session_types.map((s) => <span key={s} className="md-tag">{s}</span>)}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
}
